var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.flag_scroll),expression:"flag_scroll"}],staticClass:"backTop",on:{"click":_vm.backTop}},[_c('i',{staticClass:"el-icon-arrow-up"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }